import React from 'react';
import { observer } from 'mobx-react';
import EditDeviceComponent from './Edit-device.component';
import useEditDevice from './useEditDevice';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, groups, devices, app, lang, handlers, refs, values } =
        useEditDevice(onClose);

    return (
        <>
            <EditDeviceComponent
                lang={lang.lang}
                loading={
                    groups.addDeviceLoading ||
                    devices.changeDeviceDescriptionLoading ||
                    groups.loading ||
                    devices.loading
                }
                imei={values.imei}
                groupId={state.groupId}
                groups={groups.groupsList}
                type={state.type}
                types={values.types}
                additionalInfo={state.additionalInfo}
                keys={state.keys}
                oldDeviceName={values.deviceName}
                deviceName={state.deviceName}
                deviceIconNum={state.deviceIconNum}
                deviceNameError={state.deviceNameError}
                iconSelectVisible={state.iconSelectVisible}
                iconSelectEl={state.iconSelectEl}
                serverError={devices.serverError}
                iconSelectRef={refs.iconSelectEl}
                demoModeError={app.demoModeError}
                savedAlertVisible={state.savedAlertVisible}
                onGroupChange={handlers.handleGroupChange}
                onTypeChange={handlers.handleTypeChange}
                onAdditionalInfoChange={handlers.handleAdditionalInfoChange}
                onAdditionalInfoDateChange={
                    handlers.handleAdditionalInfoDateChange
                }
                onDeviceNameChange={handlers.handleDeviceNameChange}
                onSaveClick={handlers.handleSaveClick}
                onInputClick={handlers.handleInputClick}
                onCancelClick={onClose}
                onSelectIconBtnClick={handlers.handleSelectIconBtnClick}
                onSelectIconWindowClose={handlers.handleSelectIconWindowClose}
                onIconClick={handlers.handleIconClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onSaveAlertClose={handlers.handleSaveAlertClose}
            />
        </>
    );
};

const EditDeviceContainer = observer(Container);

export default EditDeviceContainer;
